import React from "react";
import useTranslation from "next-translate/useTranslation";
import classNames from "lib/classNames";

export default function Input({
  id,
  name,
  type,
  label,
  labelDisplay,
  placeholder,
  register,
  errors,
  suffix = null,
  required = false,
}) {
  const { t } = useTranslation("common");

  return (
    <div>
      <label
        htmlFor={id}
        className={
          labelDisplay === "invisible"
            ? "sr-only"
            : "inline-block mb-1 font-important font-medium uppercase text-sm"
        }
      >
        {label}
        {required && (
          <>
            {" "}
            <span className="text-primary">*</span>
          </>
        )}
      </label>
      <div className="relative">
        <input
          id={id}
          type={type}
          placeholder={placeholder}
          className={classNames(
            "w-full border p-4 placeholder:text-gray-300 border-opacity-50 outline-none focus:border-primary rounded",
            suffix && "pr-12"
          )}
          {...register(name, {
            required: required ? t("form.required") : false,
          })}
        />
        {suffix && (
          <span className="absolute inset-y-0 right-0 p-4 pointer-events-none">
            {suffix}
          </span>
        )}
      </div>
      {errors && (
        <p
          role="alert"
          className="block mb-2 font-semibold text-sm text-red-500"
        >
          {errors.message}
        </p>
      )}
    </div>
  );
}
